import React from "react";
import {
  setGiftCardError,
  setGiftCardSuccess,
  setPaymentError,
  setPaymentMethodsError,
  setPaymentMethodsSuccess,
  setPaymentSuccess,
  setPromoCodeError,
  setPromoCodeSuccess,
  useDiscounts,
  usePayment,
  usePaymentMethods,
} from "../../store/Store";
import Modal from "./Modal";
import { useTranslation } from "react-i18next";
import {
  isSurchargeApplicable,
  removeSurchargeFromTicketAdjustments,
} from "../surcharge/api";
import { useTicket } from "../../store/Store";
import { TransactionFailedErrorType } from "./constants";

const ModalManager = () => {
  const { t } = useTranslation();
  const { data: ticketData } = useTicket();

  const { error: paymentMethodsError, success: paymentMethodsSuccess } =
    usePaymentMethods();
  const { error: paymentError, success: paymentSuccess } = usePayment();
  const { giftCardSuccess, promoCodeSuccess, giftCardError, promoCodeError } =
    useDiscounts();

  if (giftCardSuccess) {
    return (
      <Modal
        title={t("general.success")}
        message={giftCardSuccess}
        type="confirmation"
        onClose={() => setGiftCardSuccess(null)}
      />
    );
  }

  if (promoCodeSuccess) {
    return (
      <Modal
        title={t("general.success")}
        message={promoCodeSuccess}
        type="confirmation"
        onClose={() => setPromoCodeSuccess(null)}
      />
    );
  }
  if (giftCardError) {
    return (
      <Modal
        title={t("general.error")}
        message={giftCardError}
        type="error"
        onClose={() => setGiftCardError(null)}
      />
    );
  }

  if (promoCodeError) {
    return (
      <Modal
        title={t("general.error")}
        message={promoCodeError}
        type="error"
        onClose={() => setPromoCodeError(null)}
      />
    );
  }

  if (paymentSuccess) {
    return (
      <Modal
        title={t("general.success")}
        message={paymentSuccess}
        type="confirmation"
        onClose={() => setPaymentSuccess(null)}
      />
    );
  }

  if (paymentMethodsSuccess) {
    return (
      <Modal
        title={t("general.success")}
        message={paymentMethodsSuccess}
        type="confirmation"
        onClose={() => setPaymentMethodsSuccess(null)}
      />
    );
  }

  if (paymentError) {
    return (
      <Modal
        title={
          paymentError.type == TransactionFailedErrorType
            ? t("general.declined")
            : t("general.error")
        }
        message={paymentError.message}
        type="error"
        onClose={() => {
          if (isSurchargeApplicable(ticketData))
            removeSurchargeFromTicketAdjustments(ticketData);
          setPaymentError(null);
        }}
      />
    );
  }

  if (paymentMethodsError) {
    return (
      <Modal
        title={t("general.error")}
        message={paymentMethodsError}
        type="error"
        onClose={() => setPaymentMethodsError(null)}
      />
    );
  }

  return null;
};

export default ModalManager;
